import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  offsetX: 0,
  offsetY: 0,
  offsetZ: 5
};
class RgpPos extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("rgppos.json"), DEFAULTSET);
  }
  getRgpPosSettings() {
    return this.getSettings();
  }
  saveRgpPosSettings(settings) {
    this.saveSettings(settings);
  }
}
export default RgpPos;



// WEBPACK FOOTER //
// ./src/settings/rgppos.js